export default __webpack_public_path__ + "static/media/stethoscope.97b16b2d.svg";